<template>
    <div>
        <div class="row infoBox">
            <div class="col-sm-12 pt-0 pb-12">
                <div class="tabs-container">
                    <button v-for="(student, index) of students"
                            type="button"
                            class="btn btn-link"
                            @click="changeTab(student.id, index, $event)"
                            :class="{'is-active': index === tabActive}"
                            :key="index"
                    >
                        <span>{{ studentName(student.first_name, student.last_name) }}</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="row infoBox">
            <div class="col-sm-12 pt-12">
                <div class="diary-navigation">
                    <div class="tooltip-c js-tooltip" tabindex="0">
                        <img :src="env.public_base + '/assets/images/info-icon.svg'" alt="">
                        <ul class="tooltip-c__content">
                            <!--                            <li>-->
                            <!--                                <i class="diary-status diary-status&#45;&#45;gray"></i>-->
                            <!--                                <span>Дата уроку була до підписання договору</span>-->
                            <!--                            </li>-->
                            <!--                            <li>-->
                            <!--                                <i class="diary-status diary-status&#45;&#45;orange"></i>-->
                            <!--                                <span>Довідка про хворобу. Оцінка не враховується</span>-->
                            <!--                            </li>-->
                            <!--                            <li>-->
                            <!--                                <i class="diary-status diary-status&#45;&#45;yellow"></i>-->
                            <!--                                <span>Робота перевіряється вчителем</span>-->
                            <!--                            </li>-->
                            <!--                            <li>-->
                            <!--                                <i class="diary-status diary-status&#45;&#45;red"></i>-->
                            <!--                                <span>Урок не пройдено. Оцінка не передбачена</span>-->
                            <!--                            </li>-->
                            <!--                            <li>-->
                            <!--                                <i class="diary-status diary-status&#45;&#45;red">1</i>-->
                            <!--                                <span>Урок не пройдено</span>-->
                            <!--                            </li>-->
                            <!--                            <li>-->
                            <!--                                <i class="diary-status diary-status&#45;&#45;empty"></i>-->
                            <!--                                <span>Урок пройдено. Оцінка не передбачена</span>-->
                            <!--                            </li>-->
                            <!--                            <li>-->
                            <!--                                <i class="diary-status diary-status&#45;&#45;empty">1</i>-->
                            <!--                                <span>Урок пройдено</span>-->
                            <!--                            </li>-->
                            <li class="fl-col" v-html="$t('doc_list_tooltip')"></li>
                        </ul>
                    </div>
                    <div class="btn-chat" v-if="false">
                        <a href="/" class="btn btn-blue btn-icon icon-left" @click.prevent="addDocument">
                            {{ $t('add_document') }}
                            <i class="">
                                <img :src="env.public_base + '/assets/images/icon-file-add.svg'" alt="">
                            </i>
                        </a>
                    </div>
                    <div class="diary-navigation__select">
                        <span>{{$t('rows')}}</span>
                        <multiselect
                                v-model="selectedRow"
                                :options="optionsRows"
                                :close-on-select="true"
                                placeholder=""
                                :show-labels="false"
                                :searchable="false"
                                :allow-empty="false"
                                @input="rowsChange"
                        ></multiselect>
                    </div>
                    <app-search-form :placeholder="$t('search_documents')"></app-search-form>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 pt-12 pb-12">
                <div class="table-docs">
                    <div class="table-docs__row-th">
                        <div class="table-docs__row-tr">
                            <div class="table-docs__row-td">{{ $t('date') }}</div>
                            <div class="table-docs__row-td">{{ $t('name_of_doc') }}</div>
                            <div class="table-docs__row-td">{{ $t('status') }}</div>
                            <div class="table-docs__row-td">{{ $t('author') }}</div>
                            <div class="table-docs__row-td"></div>
                        </div>
                    </div>
                    <div class="table-docs__row-tb">
                        <vue-custom-scrollbar class="scroll-area calcHeight scroll-area--mb"
                                              :settings="settingsHorizontal"
                        >
                            <template v-if="getDocuments.length === 0">
                                <div class="text-center my-20">
                                    {{ $t('nothing_found') }}
                                </div>
                            </template>
                            <template v-else>
                                <div
                                    class="table-docs__row-tr"
                                    v-for="item of getDocuments"
                                    :key="item.id"
                                >
                                    <div class="table-docs__row-td">{{ formatDate(item.created_at) }}</div>
                                    <div class="table-docs__row-td">{{ item.name }}</div>
                                    <div class="table-docs__row-td">
                                        <div class="doc-status">
                                        <span :class="[
                                            { 'red': item.status_name === 'require_sign' },
                                            { 'gray': item.status_name === 'signed' || item.doc_type === 3 || item.doc_type === 4 },
                                            { 'purple': item.status_name === 'require_account_sign' },
                                        ]">
                                            <template v-if="item.doc_type === 3 || item.doc_type === 4">
                                                {{ $t('available') }}
                                            </template>
                                            <template v-else-if="item.status_name === 'require_sign' && userData.id !== item.author.id">
                                                {{ $t('doc_status.require_sign') }}
                                            </template>
                                            <template v-else-if="item.status_name === 'signed' && userData.id !== item.author.id">
                                                {{ $t('doc_status.signed') }}
                                            </template>
                                            <template v-else-if="item.doc_type === 2 && userData.id !== item.author.id">
                                                {{ $t('doc_status.for_familiarization') }}
                                            </template>
                                            <template v-else-if="item.status_name === 'require_view' && userData.id !== item.author.id">
                                                {{ $t('doc_status.require_view') }}
                                            </template>
                                            <template v-else-if="item.status_name === 'require_account_sign' && userData.id !== item.author.id">
                                                {{ $t('doc_status.require_account_sign') }}
                                            </template>
                                            <template v-else-if="userData.id === item.author.id">
                                                {{ $t('doc_status.received') }}
                                            </template>
                                        </span>
                                        </div>
                                    </div>
                                    <div class="table-docs__row-td">
                                        <span>{{ studentName(item.author.last_name, item.author.first_name) }}</span>
                                        <i class="avatar_rouded">
                                            <img :src="item.author.photo" alt="">
                                        </i>
                                    </div>
                                    <div class="table-docs__row-td">
                                        <div class="docs-control mx-auto">
                                            <a
                                                v-if="item.doc_file"
                                                :href="item.doc_file"
                                                target="_blank"
                                                class="button button--hollow button--lg"
                                            >
                                                <strong>{{ $t('review_the_contract') }}</strong>
                                            </a>
                                            <a
                                                v-if="item.doc_signature && item.doc_type !== 3 && item.doc_type !== 4"
                                                :href="item.doc_signature"
                                                target="_blank"
                                                class="button button--hollow button--lg"
                                                style="margin-bottom: 10px;"
                                            >
                                                <strong>{{ $t('payers_document') }}</strong>
                                            </a>
                                            <a
                                                v-if="item.account_signature && item.doc_type !== 3 && item.doc_type !== 4"
                                                :href="item.account_signature"
                                                target="_blank"
                                                class="button button--hollow button--lg"
                                            >
                                                <strong>{{ $t('accountants_document') }}</strong>
                                            </a>
                                            <a
                                                v-if="!item.doc_signature && !item.is_pending && item.doc_type !== 2 && item.doc_type !== 3 && item.doc_type !== 4"
                                                href="#"
                                                target="_blank"
                                                class="button button--accent button--lg"
                                                @click.prevent="subscribeDocument(item.id)"
                                            >
                                                <strong>{{ $t('upload_doc') }} *</strong>
                                            </a>

                                            <p
                                                v-if="!item.doc_signature && !item.is_pending && item.doc_type !== 2 && item.doc_type !== 3 && item.doc_type !== 4"
                                                class="notifier"
                                            >
                                                * - {{ $t('download_time') }}
                                            </p>

                                            <div
                                                v-if="item.is_pending && item.doc_type !== 3 && item.doc_type !== 4"
                                                class="button button--hollow button--lg btn-server"
                                            >
                                                <MiniLoader />
                                                <span>{{ $t('server_processed') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </vue-custom-scrollbar>
                    </div>
                    <div class="d-flex justify-end align-center pagination-cust infoBox">
                        <div class="mr-auto" v-if="current_document_payer && current_document_payer.count > 5">
                            {{ $t('pagination_show_count.show') }} {{ start + 1 }} - {{ end }} {{ $t('pagination_show_count.rows') }} {{ current_document_payer.count }}
                        </div>
                        <app-pagination
                                v-show="current_document_payer && current_document_payer.count > 5"
                                :prevText="'<'"
                                :nextText="'>'"
                                :nextPage="current_document_payer && current_document_payer.next"
                                :prevPage="current_document_payer && current_document_payer.previous"
                                type="document_items"
                                @changePageDocumentItems="changePageDocumentItems($event)"
                        />
                    </div>
                    <div class="custom-space infoBox" style="height: 60px"></div>
                </div>
            </div>
        </div>
        <app-modal-upload-file v-if="get_visibility_modal_upload_file"
                               :studentId="currentStudentId"></app-modal-upload-file>
        <app-notification-alert v-if="notification && notification.isActive"></app-notification-alert>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import env from "../../env";
    import Multiselect from "vue-multiselect";
    import SearchForm from "../../courses/components/SearchForm";
    import ModalUploadFile from "../../payer/components/Modals/ModalUploadFile";
    import CoursePagination from "../../common_components/CoursePagination";
    import MiniLoader from "../../common_components/MiniLoader";
    import vueCustomScrollbar from 'vue-custom-scrollbar';
    import moment from "moment";
    import NotificationAlert from "../../common_components/NotificationAlert";

    export default {
        data: () => ({
            env,
            page: 1,
            tabActive: 0,
            selectedRow: '5',
            optionsRows: ['5', '10', '20'],
            settingsHorizontal: {
                maxScrollbarLength: 60,
                swipeEasing: true,
                suppressScrollY: false
            },
            currentStudentId: null
        }),
        components: {
            Multiselect,
            appSearchForm: SearchForm,
            appModalUploadFile: ModalUploadFile,
            appPagination: CoursePagination,
            vueCustomScrollbar: vueCustomScrollbar,
            appNotificationAlert: NotificationAlert,
            MiniLoader,
        },
        computed: {
            ...mapGetters([
                'search_value',
                'userData',
                'students_payer_billed',
                'get_visibility_modal_upload_file',
                'current_document_payer',
                // 'refreshPages',
                'notification'
            ]),
            students() {
                return this.students_payer_billed && typeof this.students_payer_billed.length ? this.students_payer_billed : false
            },
            getDocuments() {
                return this.current_document_payer.results && typeof this.current_document_payer.results === 'object' ? this.current_document_payer.results : []
            },
            start() {
                let start = null;
                let searchParams = (new URL(document.location)).searchParams;

                if (this.page !== searchParams.get('page')) {
                    this.page = searchParams.get('page');
                }

                if (this.current_document_payer) {
                    start = this.page >= 1 ? (this.page * this.selectedRow) - this.selectedRow : this.page * this.selectedRow;
                }
                return start
            },
            end () {
                let result = this.current_document_payer.count ? this.current_document_payer.count : 0;
                let end = this.start + +this.selectedRow;
                return result < end ? result : end;
            }
        },
        methods: {
            studentName(firstName, lastName) {
                return firstName + ' ' + lastName;
            },
            changeTab(student_id, index, event) {
                let searchParams = (new URL(document.location)).searchParams;
                let page = searchParams.get('page');
                this.tabActive = index;
                this.$store.commit('SET_SEARCH_VALUE', '');
                if (event !== undefined && event.type === 'click') {
                    this.pushToUrl(1, 'page');
                    page = 1
                }
                let data = {
                    id: student_id,
                    page_size: this.selectedRow,
                    page: page,
                };
                if (searchParams.has('q')) {
                    data.q = searchParams.get('q')
                }
                this.$store.dispatch('GET_DOCUMENTS_PAYER', data);
                this.currentStudentId = student_id;
                this.$route.params.child_id = student_id;
                this.pushToUrl(student_id, 'student');
            },
            sortDateDoc(arr) {
                return arr.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
            },
            addDocument() {
                this.$store.dispatch("setVisibilityModalUploadFile", {
                    show: true,
                });
            },
            subscribeDocument(id) {
                this.$store.dispatch('setVisibilityModalUploadFile', {
                    show: true,
                    doc_id: id
                });
            },
            formatDate(date) {
                return moment(date).format('YYYY-MM-DD')
            },
            changePageDocumentItems(event) {
                this.page = event.page;
                this.$store.dispatch('GET_DOCUMENTS_PAYER', {
                    id: this.currentStudentId,
                    page: event.page,
                    page_size: this.selectedRow,
                    q: this.search_value
                })
            },
            pushToUrl(val, param) {
                let url = new URL(window.location);
                if (url.searchParams.get(param) === null) {
                    url.searchParams.append(param, val)
                } else {
                    url.searchParams.set(param, val)
                }
                if (val === '') {
                    url.searchParams.delete(param)
                }
                window.history.pushState({path: url.href}, '', url.href);
            },
            rowsChange(val) {
                let searchParams = (new URL(document.location)).searchParams;
                if (val !== searchParams.get('rows')) {
                    this.pushToUrl(val, 'rows');
                    this.pushToUrl(1, 'page');
                    this.$store.dispatch('GET_DOCUMENTS_PAYER', {
                        id: this.currentStudentId,
                        page: 1,
                        page_size: val,
                        q: this.search_value
                    });
                    this.$store.commit('SET_REFRESH_PAGES', searchParams)
                }
            }
        },
        created() {
            let searchParams = (new URL(document.location)).searchParams;
            if (searchParams.has('rows')) this.selectedRow = searchParams.get('rows');
            if (searchParams.has('q')) {
                this.$store.commit('SET_SEARCH_VALUE', searchParams.get('q'));
            }

            if (searchParams.has('student')) {
                this.currentStudentId = searchParams.get('student');
                this.$route.params.child_id = searchParams.get('student');
                this.changeTab(searchParams.get('student'), this.students_payer_billed.findIndex((e, i) => e.id === +searchParams.get('student')));
            } else if (this.students.length) {
                this.pushToUrl(this.students[0].id, 'student');
                this.$route.params.child_id = this.students[0].id;
                this.currentStudentId = this.students[0].id;
            }

            let data = {
                id: this.currentStudentId,
                page: searchParams.get('page'),
                page_size: this.selectedRow
            };

            if (searchParams.has('q')) {
                data.q = searchParams.get('q')
            }

            this.$store.dispatch('GET_DOCUMENTS_PAYER', data);
        },
        watch: {
            current_document_payer() {
                this.calcHeight();
            },
            $route() {
                this.$store.dispatch('GET_DOCUMENTS_PAYER', {
                    id: this.currentStudentId,
                    page_size: this.selectedRow,
                    q: this.search_value
                });
            },
            selectedRow: {
                handler(val, oldVal) {
                    this.rowsChange(val);
                },
                deep: true
            },
            search_value: {
                handler(val) {
                    this.pushToUrl(val, 'q');
                    this.pushToUrl(1, 'page');
                },
                deep: true
            }
        },
        mounted() {
            this.$nextTick(() => {
                const tooltip = document.querySelector('.js-tooltip');
                tooltip.focus();
            });
        },
    }
</script>

<style scoped lang="sass">
    @import "../../../sass/variables"
    @import "../../../sass/cabinet"
    @import "../../../sass/teacherLesson"
    @import "../../../sass/teacherCheckwork"
    @import "../../../sass/studentStat"
    @import "../../../sass/teacherMaterials"
    @import "../../../sass/payer"
    @import "../../../sass/payerCommon"
    @import "../../../sass/documentsTable"

    .pt-0
        padding-top: 0

    .pb-0
        padding-bottom: 0

    .mx-auto
        margin: 0 auto

    .mr-auto
        margin-right: auto

    .my-20
        margin: 20px 0

    .align-center
        align-items: center

    .justify-end
        justify-content: flex-end

    .search__input
        background: $white

    .diary-navigation
        display: flex
        align-items: center
        justify-content: space-between

        .chat-head__search
            margin-left: 20px

    .diary-navigation__select
        display: flex
        align-items: center
        margin-left: auto

        .multiselect
            margin-left: 15px
            min-width: 80px
            max-width: 80px

    .btn-chat a.icon-left
        padding: 10px 15px 10px 45px
        margin-left: 0

    .btn-chat i
        background-color: #1A8FBF
        padding-left: 10px
        padding-right: 10px

    .tooltip-c
        margin-right: 30px

    .fl-col
        flex-direction: column

    .btn-server
        display: flex
        padding: 0
        align-items: center
        font-weight: 400
        border: none

        .lds-dual-ring
            margin-right: 10px

        &:hover
            opacity: 1

    .notifier
        font-size: 12px
        color: #999999
        margin-top: 5px

    .docs-control
        width: 100%
        max-width: 180px
</style>
